module.exports = __webpack_public_path__ + "static/img/img1.c65d4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202111/img1.png
// module id = m2DA
// module chunks = 0